import React, { useRef } from "react";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import TextField from "@mui/material/TextField";
import { getNestedError } from "utils";
import "react-datepicker/dist/react-datepicker.css";
import { Svg } from "assets";

export const YearCalendar = ({
  className,
  labelHeader,
  placeholder,
  control,
  rules,
  name,
}) => {
  const inputRef = useRef(null);

  return (
    <div
      className={`input-main-wrapper input-custom-wrapper ${
        className ? className : ""
      }`}
    >
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field, formState: { errors } }) => {
          const error = getNestedError(errors, name);
          const hasError = !!error?.type;

          if (hasError && inputRef.current) {
            // inputRef.current.focus();
            inputRef.current.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
            const dateValue = field?.value instanceof Date && !isNaN(field?.value)
                ? field?.value
                : null;

          return (
            <>
              {labelHeader && (
                <p
                  className={`input-main-label-header ${
                    error?.message?.message ? "errorLabel" : ""
                  }`}
                >
                  {labelHeader}
                  {rules?.required && (
                    <span className="input-main-label-header-required">*</span>
                  )}
                </p>
              )}
              <DatePicker
                {...field}
                selected={dateValue}
                showYearPicker
                dateFormat="yyyy"
                placeholderText={placeholder}
                customInput={
                  <TextField
                    inputRef={(el) => {
                      field.ref(el);
                      inputRef.current = el;
                    }}
                    InputProps={{
                      endAdornment: <Svg.CalendarSvg />,
                    }}
                  />
                }
              />
              <p className="error-message">{error?.message}</p>
            </>
          );
        }}
      />
    </div>
  );
};
